import { render, staticRenderFns } from "./xskCascader.vue?vue&type=template&id=64aafdb2&"
import script from "./xskCascader.vue?vue&type=script&lang=js&"
export * from "./xskCascader.vue?vue&type=script&lang=js&"
import style0 from "./xskCascader.vue?vue&type=style&index=0&id=64aafdb2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports